export default {
  //baseURL: 'http://server:8000/',
  baseURL: window.location.origin,
};
